import actions from "./actions.js";
import mutations from "./mutations.js";

export const initialState = () => {
  return {
    showDialog: false,
    dialogTitle: "Title",
    dialogText: "Text",
    okText: "Ok",
    cancelText: "Cancel",
    onOk: () => {},
    onCancel: () => {},
    resolve: null,
    maxWidth: null,
    icon: undefined,
    layer: 0
  };
};

export const okCancelDialogModule = {
  state: initialState(),
  namespaced: true,
  getters: {},
  actions,
  mutations
};
